import { gql } from '@apollo/client';
import NotificationMessageDTO from './fragments/notificationMessageDTO.fragment.notification';

export default gql`
  query getOpenNotifications($pageSize: Int!, $token: String) {
    getOpenNotifications(input: { pageSize: $pageSize, token: $token }) {
      token
      notifications {
        ...NotificationMessageDTO
      }
    }
  }
  ${NotificationMessageDTO}
`;
